// extracted by mini-css-extract-plugin
module.exports = {"container":"Wallet_container__FqS3c","item_container":"Wallet_item_container__EWmgx"};